import type { Lang } from "@noli/core";

import { injectScope } from "./util";

export enum User_Assets_Words {
  "rest" = "rest",
  "total_coin" = "total_coin",
  "paid_coin" = "paid_coin",
  "paid_heart_coin" = "paid_heart_coin",
  "paid_coin_vip_tip" = "paid_coin_vip_tip",
  "free_coin" = "free_coin",
  "free_coin_use_tip" = "free_coin_use_tip",
  "get_more_coin" = "get_more_coin",
  "cost" = "cost",
  "coins_use_for_tip" = "coins_use_for_tip",
}

injectScope("user_assets", User_Assets_Words);

export const userAssetsLangRecord: Record<Lang, Record<User_Assets_Words, string>> = {
  zh: {
    [User_Assets_Words.rest]: "剩余",
    [User_Assets_Words.total_coin]: "画力星",
    [User_Assets_Words.paid_coin]: "付费星",
    [User_Assets_Words.paid_heart_coin]: "付费画力星",
    [User_Assets_Words.paid_coin_vip_tip]: "画宇宙系列模型可无限使用，不消耗画力星",
    [User_Assets_Words.free_coin]: "免费星",
    [User_Assets_Words.free_coin_use_tip]: "（仅在使用画宇宙系列模型有效）",
    [User_Assets_Words.get_more_coin]: "获得更多画力星",
    [User_Assets_Words.cost]: "消耗",
    [User_Assets_Words.coins_use_for_tip]:
      "免费星可于画宇宙系列模型、全部画宇宙小模型\n付费星可用于所有模型",
  },
  en: {
    [User_Assets_Words.rest]: "Rest ",
    [User_Assets_Words.total_coin]: "coins",
    [User_Assets_Words.paid_coin]: "paid coins",
    [User_Assets_Words.paid_heart_coin]: "paid coins",
    [User_Assets_Words.paid_coin_vip_tip]: "Nolibox Model does not cost coins",
    [User_Assets_Words.free_coin]: "free coins",
    [User_Assets_Words.free_coin_use_tip]: " (Only be applied to Nolibox Model) ",
    [User_Assets_Words.get_more_coin]: "Get more coins",
    [User_Assets_Words.cost]: "Cost",
    [User_Assets_Words.coins_use_for_tip]:
      "Free coins can be applied to Nolibox series Model and all Nolibox small Models; paid coins can be applied to ALL Models",
  },
};
